<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :data="model"
                   :title="model.uuid ? $t(`Update Customer Link`) : $t(`Create New Customer Link`)"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   :content-in-form="false"
                   scrollable>
      <div class="d-block">
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <div class="row">
            <div class="col-md-6">
              <customer-select-input-widget :model="model" attribute="to_customer_uuid"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="first_name"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="last_name"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="email"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="phone"/>
            </div>
            <div class="col-md-6">
              <input-widget :items="linkTypes" value-field="value" display-field="${item.key}" type="select2"
                            :model="model" attribute="description"/>
            </div>
            <div class="col-md-6">
              <input-widget v-if="model.description === 'Other (free text)'"
                            :model="model" type="text" attribute="description_text"/>
            </div>
          </div>
        </b-form>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import CustomerSelectInputWidget from "../../../../../core/widgets/CustomerSelectInputWidget";
  import CustomerLinkForm from "../../../models/CustomerLinkForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "CustomerLinkModal",
    components: {CustomerSelectInputWidget, InputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        // This indicates that modal should show confirmation dialog when something is changed inside, and we are trying
        // to close the modal
        showConfirmation: true,
        model: new CustomerLinkForm(),
        linkTypes: [
          {key: this.$i18n.t('Auction Contact Person'), value: 'Auction Contact Person'},
          {key: this.$i18n.t('Other (free text)'), value: 'Other (free text)'},
        ],
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        modal: state => state.customerLinkModal,
        editObject: state => state.customerLinkModal.object
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {

          let tmpLinkObj = this.editObject;

          if (tmpLinkObj.description &&
              tmpLinkObj.description !== '' &&
              !this.linkTypes.find(a => a.value === tmpLinkObj.description)) {

            tmpLinkObj.description_text = tmpLinkObj.description;
            tmpLinkObj.description = 'Other (free text)';
          }


          this.model = new CustomerLinkForm(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['hideCustomerLinkModal', 'createCustomerLink', 'updateCustomerLink']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new CustomerLinkForm();
        this.hideCustomerLinkModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;
        this.model.customer_uuid = this.customer.uuid;
        if (!this.model.uuid) {
          response = await this.createCustomerLink(this.model);
        } else {
          response = await this.updateCustomerLink(this.model);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideCustomerLinkModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Customer link was successfully created'));
          } else {
            this.$toast('success', this.$t('Customer link was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
